<template>
  <div :class="classes" class="relative"
       @click="$emit('click')"
       v-ripple>
    <div class="button-label">{{ label }}</div>
    <number-badge v-if="showBadge"
                  :style="isTab?`position:relative;right:-2px`:'position:absolute;right:-5px'"
                  :badgeColor="badgeColor"
                  :offsetX="offsetX"
                  :offsetY="offsetY"
                  :count="count"></number-badge>
  </div>
</template>

<script>
import NumberBadge from '@/components/decorators/NumberBadge';

export default {
  name: 'RoundedButton',
  props: {
    label: String,
    badgeColor: String,
    offsetX: Number,
    offsetY: Number,
    count: Number,
    isSelected: {type: Boolean, default: false},
    showBadge: {type: Boolean, default: true},
    isTab: {type: Boolean, default: false},
  },
  components: {
    NumberBadge,
  },
  computed: {
    classes() {
      return {
        'selected-tab': this.isSelected,
        'tab': this.isTab,
        'button': !this.isTab
      }
    }
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  margin: 0;
  height: 100%;
  padding: 3px 6px;

  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.theme--light .tab{
  background: #e0e0e0;
}

.theme--dark .tab {
  background: #202020;
}
.selected-tab{
  font-weight: bolder !important;
}
.theme--light .selected-tab{
  background: #d0d0d0;

  border-bottom:3px solid #404040
}

.theme--dark .selected-tab {
  background: #303030;
  border-bottom:3px solid #808080
}

.button {
  border-radius: 1.6rem;
  display: flex;
  margin: 4px;
  padding: 3px 6px;


  flex-direction: row;
}
.theme--light .button{
  background: #e0e0e0;
  border: 1px solid #808080;
}
.theme--dark .button {
  background: #444444;
  border: 1px solid #606060;
}

.button-label {
  white-space: nowrap;
  overflow: hidden;
  margin-right: 0;
  text-overflow: ellipsis;
  font-size:0.875rem
}
</style>